<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card justify="center">
        <v-card-title class="subtitle-1 light-green lighten-3">メッセージ</v-card-title>
        <br/>
        <v-row style="width: 100%;">
          <v-col md="12" align="left">
            <div style="margin-left: 10%; font-size: 0.8em" v-html='msg'></div>
          </v-col>
        </v-row>
        <br/>
        <v-divider></v-divider>
    
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded class="light-green lighten-3" dark @click="yes()"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["msg", "isOpen", "doYes"],
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    isOpen: function (val) {
      this.dialog = val;
    },
  },
  methods: {
    yes() {
      this.doYes();
      this.dialog = false;
    },
  },
};
</script>